import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BrainCircuit } from 'lucide-react';
export function NotYourFault() {
  return <section className="w-full bg-[#FDFBFF] py-16 md:py-24 px-6 border-t border-purple-50" data-id="element-237">
      <div className="max-w-3xl mx-auto" data-id="element-238">
        <FadeIn data-id="element-239">
          <div className="flex justify-center mb-6" data-id="element-240">
            <div className="p-4 bg-purple-100 rounded-full" data-id="element-241">
              <BrainCircuit className="w-6 h-6 md:w-8 md:h-8 text-purple-600" data-id="element-242" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-serif text-night-900 text-center mb-10 md:mb-12" data-id="element-243">
            El problema no eres tú. Es lo que nadie te explicó.
          </h2>
        </FadeIn>

        <div className="space-y-5 md:space-y-6 text-lg md:text-xl text-slate-700 leading-relaxed" data-id="element-244">
          <FadeIn delay={0.1} data-id="element-245">
            <p data-id="element-246">
              Tu sistema nervioso fue diseñado para mantenerte alerta ante el
              peligro.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-247">
            <p data-id="element-248">
              El problema es que hoy el "peligro" son los emails sin responder,
              las conversaciones que quedaron pendientes, la lista de tareas de
              mañana y las mil cosas que sientes que dependen de ti.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-249">
            <p className="font-medium text-night-900" data-id="element-250">
              Tu cerebro no distingue entre un tigre y una lista de pendientes.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-251">
            <p data-id="element-252">
              Para él, todo es urgente. Todo necesita solución. Todo es ahora.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-253">
            <p data-id="element-254">
              Y cuando te acuestas en silencio por primera vez en todo el día...
              ese sistema aprovecha para procesarlo todo de golpe.
            </p>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} data-id="element-255">
          <div className="mt-10 md:mt-12 border-l-4 border-purple-400 pl-5 md:pl-6 py-2" data-id="element-256">
            <p className="text-lg md:text-xl text-night-900 font-medium mb-3 md:mb-4" data-id="element-257">
              El resultado: una mente que se prende exactamente cuando más
              necesitas que se apague.
            </p>
            <p className="text-base md:text-lg text-slate-600" data-id="element-258">
              La buena noticia es que esto tiene solución. Y es más simple de lo
              que imaginas.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}